import { useMemo } from 'react';
import { SimpleBars } from '../../Common/Charts/SimpleBars';
import { useEpidemiologyChartsDataContext } from './hooks/useEpidemiologyChartsDataContext';

export const TopMortalityCids = () => {
    const { chartData } = useEpidemiologyChartsDataContext();

    const { subtitles, values } = useMemo(() => {
        const items = (chartData?.topMortalityCids || [])
            .slice()
            .sort(
                (a, b) =>
                    Number(b?.taxa_morte_pct || 0) -
                    Number(a?.taxa_morte_pct || 0)
            )
            .slice(0, 10);

        return {
            subtitles: items.map(
                (item) => `${item?.cid} - ${item?.nome || 'Não informado'}`
            ),
            values: items.map(
                (item) => Number(item?.taxa_morte_pct || 0)
            )
        };
    }, [chartData]);

    return (
        <SimpleBars
            title="CIDs com Maior Taxa de Mortalidade (%)"
            horizontal={true}
            subtitles={subtitles}
            values={values}
            showDataLabels={true}
            height={520}
        />
    );
};